// extracted by mini-css-extract-plugin
export var chevron = "_o8-1";
export var clickable = "_o8-0";
export var ruleRow = "_o8-2";